
//#region import libraries
import React from "react";
//styles
import { Colors } from "_styles";
//bottstrap
import { Col } from "react-bootstrap";
//icons
import { GoChevronLeft, GoChevronRight } from "react-icons/go";
//#endregion

//departuresSkip + limit > departuresCount ? departuresCount : departuresSkip + limit)
//custom component for rows count (from-to)
const TableCount = ({ totalRows, limit, skippedRows }) => {
    const endSkipped = limit + skippedRows > totalRows ? totalRows : limit + skippedRows
    const count = `${skippedRows}-${endSkipped} of ${totalRows}`
    return (
        <p>{count}</p>
    )
}
const Pagination = ({ showLess, showMore, limit = 25, skippedRows, totalRows, handleLimitChange }) => {


    return (
        <Col>
            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", rowGap: 8, marginLeft: -6 }}>
                <TableCount limit={limit} skippedRows={skippedRows} totalRows={totalRows} />
                <GoChevronLeft
                    onClick={showLess}
                    size={24}
                    style={{
                        cursor: skippedRows - limit < 0 ? null : "pointer",
                        opacity: skippedRows - limit < 0 ? 0.3 : 1.0,
                        pointerEvents: skippedRows - limit < 0 ? "none" : "auto",
                    }}
                    color={Colors.PRM_LIGHT_BLUE}
                />
                <GoChevronRight
                    onClick={showMore}
                    size={24}
                    style={{
                        marginLeft: 28,
                        cursor: skippedRows + limit > totalRows ? null : "pointer",
                        opacity: skippedRows + limit > totalRows ? 0.3 : 1.0,
                        pointerEvents: skippedRows + limit > totalRows ? "none" : "auto",
                    }}
                    color={Colors.PRM_LIGHT_BLUE}
                />

                <label style={{ marginLeft: '16px' }}>
                    Rows per page:
                    <select value={limit} onChange={handleLimitChange} style={{ marginLeft: '8px' }}>
                        {[10, 25, 50, 75, 100].map((option) => (
                            <option key={option} value={option}>{option}</option>
                        ))}
                    </select>
                </label>
            </div>
        </Col>
    )
}


export default Pagination;